module.exports = __webpack_public_path__ + "img/jewelrybox@2x.723c7b2.webp";